import _ from 'lodash';
import React from 'react';

import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';

import {
  MODALS,
  fetchTeamDetail,
  deleteTeam,
  fetchMyTeams,
  fetchAllTeams
} from 'ducks/teams';
import {
  MODALS as BASE_MODALS,
  closeModal,
  selectModal,
  openModal
} from 'ducks/modals';
import {
  requiresPermission,
  requiresPermissionOrTeamOwnership,
  PERMISSIONS
} from 'ducks/auth';

import {MembersTable, TeamSection} from './components';

import {LocationsSection} from 'containers/MyTeams/components/shared';

import './styles.css';

class TeamDetailsModal extends React.Component<any> {
  componentDidMount() {
    const {teamId} = this.props.data;

    this.props.fetchTeamDetail(
      {teamId},
      this.props.storeDataExtraActions(data => ({team: data}))
    );
  }

  openEditTeamModal = ({teamId}) =>
    this.props.requiresPermissionOrTeamOwnership(
      {teamId, permission: PERMISSIONS.EDIT_TEAM_DETAILS},
      () => this.props.openModal(MODALS.EDIT_TEAM_DETAILS, {teamId})
    );

  openSetInactivityLogoutModal = ({teamId}) =>
    this.props.requiresPermission(
      {permission: PERMISSIONS.SET_TEAM_INACTIVITY_TIMER},
      () => this.props.openModal(MODALS.SET_INACTIVITY_LOGOUT, {teamId})
    );

  openManageTeamPermissionsModal = ({teamId}) =>
    this.props.requiresPermission(
      {permission: PERMISSIONS.EDIT_TEAM_PERMISSIONS},
      () => this.props.openModal(MODALS.MANAGE_TEAM_PERMISSIONS, {teamId})
    );

  openManageLocationsModal = ({teamId}) =>
    this.props.requiresPermission(
      {permission: PERMISSIONS.EDIT_TEAM_LOCATIONS},
      () => this.props.openModal(MODALS.MANAGE_TEAM_LOCATIONS, {teamId})
    );

  openManageMembersModal = ({teamId}) =>
    this.props.requiresPermissionOrTeamOwnership(
      {teamId, permission: PERMISSIONS.EDIT_TEAM_MEMBERS},
      () => this.props.openModal(MODALS.MANAGE_MEMBERS, {teamId})
    );

  openDeleteTeamConfirmationModal = () => {
    const {team} = this.props.data;

    const confirmAction = () =>
      this.props.deleteTeam({teamId: team.id}, [
        () => closeModal(BASE_MODALS.CONFIRM),
        () => closeModal(MODALS.TEAM_DETAILS),
        () => fetchMyTeams(),
        () => fetchAllTeams()
      ]);

    const question = (
      <div>
        Are you sure you want to delete the team <b>{team.name}</b>?
      </div>
    );

    this.props.requiresPermission({permission: PERMISSIONS.DELETE_TEAM}, () =>
      this.props.openModal(BASE_MODALS.CONFIRM, {
        danger: true,
        heading: 'Delete Team',
        question,
        confirmAction
      })
    );
  };

  render() {
    const {data: {team}} = this.props;

    const locations = _.get(team, 'locations');
    const members = _.get(team, 'members');

    return (
      <Modal
        className="TeamDetailsModal"
        type={Modal.MEDIUM}
        show={true}
        onClose={this.props.closeModal}>
        <Modal.Header heading="Team Details" />
        <Modal.Body>
          {!_.isNil(team) && (
            <TeamSection
              team={team}
              openEditTeamModal={this.openEditTeamModal}
              openManageTeamPermissionsModal={
                this.openManageTeamPermissionsModal
              }
              openManageLocationsModal={this.openManageLocationsModal}
              openDeleteTeamConfirmationModal={
                this.openDeleteTeamConfirmationModal
              }
              openSetInactivityLogoutModal={this.openSetInactivityLogoutModal}
            />
          )}
          {!_.isEmpty(locations) && <LocationsSection locations={locations} />}
          {!_.isEmpty(members) && <MembersTable members={members} />}
        </Modal.Body>
        <Modal.Footer>
          {team && (
            <Button
              white
              onClick={() => this.openManageMembersModal({teamId: team.id})}>
              Manage Members
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const {data: {team}} = selectModal(state, MODALS.TEAM_DETAILS);

  return {team};
};

const mapDispatchToProps = {
  fetchTeamDetail,
  deleteTeam,
  openModal,
  requiresPermission,
  requiresPermissionOrTeamOwnership
};

export default withModal(
  MODALS.TEAM_DETAILS,
  mapStateToProps,
  mapDispatchToProps
)(TeamDetailsModal);
